<template lang="pug">
  #app
    //- transition(name="component-fade", mode="out-in")
    router-view.router-view
</template>

<script>
export default {
  name: 'home',
};
</script>

<style lang="scss">
.component-fade-enter-active, .component-fade-leave-active {
  transition: opacity .3s ease;
}
.component-fade-enter, .component-fade-leave-to {
  opacity: 0;
}
</style>
